









































































































import { checkPermissions } from '@/directives/permissionDirective'
import { ADMColumn } from '@/interfaces/adm-columns.interface'
import { Filter } from '@/interfaces/filter.interface'
import { APIPagination } from '@/models/api/pagination.model'
import { APIRole } from '@/models/api/role.model'
import { Component, Vue } from 'vue-property-decorator'
import ReportFavorites from './ReportFavorite.vue'
import ReportFilters from './ReportFilters.vue'
import ReportList from './ReportList.vue'

@Component({
    components: {
        ReportList,
        ReportFilters,
        ReportFavorites
    }
})
export default class Report extends Vue {
    loading = false
    loadingFavorite = false
    mainTitle = 'Reports'
    permissionPrefix = 'report'
    filters: Filter[] = []
    dateFilter: string[][] = []
    data: object[] = []
    dataFavorite: object[] = []
    isAdmin = false

    sortBy = ''
    sortByDesc = false

    selectedRows = []
    selectRows = false
    customColums: ADMColumn[] = []
    customColumsFavorite: ADMColumn[] = []
    columns: ADMColumn[] = [
        {
            text: 'ID',
            value: 'reportId'
        },
        {
            text: 'Name',
            value: 'reportName'
        },
        {
            text: 'Category',
            value: 'categoryId.categoryName',
            sortable: false
        },
        {
            text: 'Owner',
            value: 'userId.username',
            sortable: false
        },
        {
            text: 'Chart Type',
            value: 'chartTypeId',
            customField: {
                type: 'boolean'
            }
        },
        {
            text: 'Private',
            value: 'reportPrivateEnabled',
            customField: {
                type: 'boolean'
            }
        },
        {
            text: 'Actions',
            width: '100px',
            customField: {
                type: 'options',
                hideAll: false
            }
        }
    ]

    columnsFavorite: ADMColumn[] = [
        {
            text: 'ID',
            value: 'reportId.reportId'
        },
        {
            text: 'Name',
            value: 'reportId.reportName'
        },
        {
            text: 'Category',
            value: 'reportId.categoryId.categoryName'
        },
        {
            text: 'Owner',
            value: 'reportId.userId.username'
        },
        {
            text: 'Chart Type',
            value: 'reportId.chartTypeId',
            customField: {
                type: 'boolean'
            }
        },
        {
            text: 'Private',
            value: 'reportPrivateEnabled',
            customField: {
                type: 'boolean'
            }
        },
        {
            text: 'Actions',
            width: '100px',
            customField: {
                type: 'options',
                hideAll: false
            }
        }
    ]

    eventFilters = {}

    rowsPerPage = 15
    pagination: APIPagination = {
        currentPage: 1,
        total: 0,
        nextPage: null,
        previousPage: null
    }

    rowsPerPageFavorite = 15
    paginationFavorite: APIPagination = {
        currentPage: 1,
        total: 0,
        nextPage: null,
        previousPage: null
    }

    reportEdit ={}

    checkPermision (permission: string) {
        return !!checkPermissions(permission)
    }

    get userData () {
        return this.$store.state.AuthStore.auth.user
    }

    newLimitHandler (val: number) {
        this.rowsPerPage = val
        this.pagination = {
            currentPage: 1,
            total: 0,
            nextPage: null,
            previousPage: null
        }
        this.loadData()
    }

    newLimitHandlerPaginate (val: number) {
        this.rowsPerPageFavorite = val
        this.paginationFavorite = {
            currentPage: 1,
            total: 0,
            nextPage: null,
            previousPage: null
        }
        this.loadDataFavorite()
    }

    paginationFavoriteTable (val: number) {
        this.paginationFavorite.currentPage = val
        this.loadDataFavorite()
    }

    paginationTable (val: number) {
        this.pagination.currentPage = val
        this.loadData()
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    loadFilters (event: any) {
        this.eventFilters = event
        this.filters.map((item) => {
            if (event.reportId && item.text === 'reportId') {
                item.queryValue = event.reportId
                item.values = event.reportId
            }
            if (event.reportName && item.text === 'reportName') {
                item.queryValue = event.reportName
                item.values = event.reportName
            }
            if (event.categoryId && item.text === 'categoryId') {
                item.queryValue = event.categoryId
                item.values = event.categoryId
            }
            if (event.datasourceId && item.text === 'datasourceId') {
                item.queryValue = event.datasourceId
                item.values = event.datasourceId
            }
            if (event.chartTypeId && item.text === 'chartTypeId') {
                item.queryValue = event.chartTypeId
                item.values = event.chartTypeId
            }
            if (event.roles && item.text === 'roles') {
                item.queryValue = event.roles
                item.values = event.roles
            }
            return item
        })
        this.loadData()
    }

    resetFilters () {
        this.getFilters()
        this.loadData()
    }

    loadReportList (sort: { sortBy: string; sortByDesc: boolean }) {
        this.sortBy = sort.sortBy
        this.sortByDesc = sort.sortByDesc
        this.loadData()
    }

    loadData () {
        this.loading = true
        const user = JSON.parse(JSON.stringify(this.userData))
        this.isAdmin = user.roles?.filter((x: APIRole) => {
            return x.roleId === 1
        })
        const role = user.roles?.map((x: APIRole) => {
            if (x.roleId === 1) {
                return x.roleId
            }
        })
        this.filters.forEach((filter, i) => {
            if (filter.text === 'roles' && !this.isAdmin) {
                filter.queryValue = role
                filter.values = role
            }

            if (filter.type === 'date') {
                filter.queryValue = this.dateFilter[i]
            }
        })

        this.$store.dispatch('getReportsPaginate', {
            page: this.pagination.currentPage,
            filters: this.filters,
            limit: this.rowsPerPage,
            sortBy: this.sortBy,
            sort: this.sortByDesc ? 'asc' : 'desc'
        })
            .then(resp => {
                if (resp?.status === 200) {
                    this.pagination = { ...this.$store.state.ReportsStore.reportsPaginate }
                    this.data = this.$store.state.ReportsStore.reportsPaginate.results || []
                    if (this.pagination.results) delete this.pagination.results

                    if (!this.pagination?.currentPage) this.pagination.currentPage = 1

                    this.loading = false
                }
            })
    }

    loadDataFavorite () {
        this.loadingFavorite = true
        const user = JSON.parse(JSON.stringify(this.userData))
        const filters = [
            {
                text: 'userId',
                type: 'number',
                value: 'userId',
                queryValue: user.userId,
                values: []
            }
        ]
        this.$store.dispatch('getReportFavoritesPaginate', { page: this.paginationFavorite.currentPage, filters, limit: this.rowsPerPageFavorite })
            .then(resp => {
                if (resp?.status === 200) {
                    this.paginationFavorite = { ...this.$store.state.ReportsStore.reportFavoritesPaginate }
                    this.dataFavorite = this.$store.state.ReportsStore.reportFavoritesPaginate.results || []
                    if (this.paginationFavorite.results) delete this.paginationFavorite.results

                    if (!this.paginationFavorite?.currentPage) this.paginationFavorite.currentPage = 1
                    this.loadingFavorite = false
                }
            })
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    editField (field: any) {
        this.$router.push({
            name: this.$route.meta.formRoute,
            params: {
                action: 'edit',
                id: field.reportId
            }
        })
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    viewReport (field: any) {
        this.$router.push({
            name: 'ReportView',
            params: {
                reportId: field.reportId
            }
        })
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    addRolesField (field: any) {
        this.$router.push({
            name: 'ReportRolesForm',
            params: {
                action: 'route',
                id: field.reportId
            }
        })
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    reportAgend (field: any) {
        this.$router.push({
            name: 'ReportAgend',
            params: {
                reportId: field.reportId
            }
        })
    }

    getFilters () {
        this.filters = [
            {
                text: 'reportId',
                type: 'text',
                value: 'reportId',
                queryValue: '',
                values: []
            },
            {
                text: 'reportName',
                type: 'text',
                value: 'reportName',
                queryValue: '',
                values: []
            },
            {
                text: 'categoryId',
                type: 'select',
                value: 'categoryId',
                queryValue: '',
                values: []
            },
            {
                text: 'datasourceId',
                type: 'select',
                value: 'datasourceId',
                queryValue: '',
                values: []
            },
            {
                text: 'chartTypeId',
                type: 'select',
                value: 'chartTypeId',
                queryValue: '',
                values: []
            },
            {
                text: 'roles',
                type: 'select',
                value: 'roles',
                queryValue: '',
                values: []
            }
        ]
    }

    async mounted () {
        this.columns.forEach(column => {
            if (column.customField) this.customColums.push(column)
        })
        this.columnsFavorite.forEach(column => {
            if (column.customField) this.customColumsFavorite.push(column)
        })
        this.getFilters()
        this.loadData()
        this.loadDataFavorite()
    }
}
